<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex md12 xs12 d-flex>
        <v-card>
          <v-card-title class="pb-0">
            <v-layout align-center justify-space-between fill-height>
              <v-flex xs12>
                <h5 class="headline text-uppercase text-green">
                  {{ `app.mobile_app.header` | trans }}
                </h5>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-container>
              <v-layout wrap>
                <v-flex xs12 v-if="hasEmail">
                  <span class="subheading">{{ `app.mobile_app.status` | trans }}:</span>
                  <span :class="{'text-green': appConfigured, 'text-orange': invitedToMobileApp || invitationAccepted}">{{
                      mobileAppStatus
                    }}</span>
                </v-flex>
                <v-flex xs12 v-if="appConfigured">
                  <span class="subheading">{{ `app.mobile_app.notifications_enabled` | trans }}:</span>
                  <span class="text-green" v-if="mobileAppAccess.settings.notificationsEnabled">{{ `app.enabled` | trans }}</span>
                  <span class="text-orange" v-else>{{ `app.disabled` | trans }}</span>
                </v-flex>
                <v-flex xs12 v-if="appConfigured">
                  <span class="subheading">{{ `app.mobile_app.version` | trans }}:</span>
                  <span>{{ mobileAppAccess.app_version }}</span>
                </v-flex>
                <v-flex xs12 v-if="hasEmail && !invitationAccepted && !appConfigured">
                  <v-layout row align-center justify-center>
                    <v-flex xs12 class="text-xs-center">
                      <v-btn color="primary" @click="sendInvitation()" :disabled="loading">
                        {{
                          (invitedToMobileApp ? 'app.mobile_app.resend_invitation' : 'app.mobile_app.send_invitation') | trans
                        }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-if="!hasEmail">
                  <v-alert :value="true" type="warning">
                    <div v-html="getEmailMissing()"></div>
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-container>
            <v-divider/>
            <nutrients-form ref="nutrientsForm" v-if="appConfigured" :title="'Wartości odżywcze wyświetlane w aplikacji'" :max-nutrients="12" :route="`/v2/mobile-app/${patient_id}/displayed-nutrients`" :permission="'patient_mobile_app_invite'"/>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import {trans} from "../../../app";
import MobileAppService from "../../../services/MobileAppService";

export default {
  props: {
    patient_id: {
      type: Number,
    }
  },
  data() {
    return {
      loading: false,
    }
  },
  mounted() {
    this.fetchPatient(this.patient_id).then(() => {
      this.fetchMobileAppAccess(this.patient_id).then(async () => {
        if (this.appConfigured) {
          await this.$refs.nutrientsForm.setCurrentNutrients(this.mobileAppAccess.settings.displayedNutrients);
        }
      })
    });
  },
  methods: {
    ...mapActions(['fetchPatient', 'fetchMobileAppAccess']),
    getEmailMissing() {
      return trans('app.mobile_app.email_missing', {'patient_id': this.patient_id});
    },
    sendInvitation() {
      this.loading = true;
      new MobileAppService().invitePatient(this.patient_id)
          .then(() => {
            this.fetchMobileAppAccess(this.patient_id)
                .then(() => {
                  this.$toasted.global.success({
                    message: trans('app.mobile_app.invitation_sent'),
                  });
                  this.loading = false;
                })
                .catch(() => {
                  this.loading = false;
                  this.$toasted.global.error({
                    message: trans('app.error_occurred'),
                  });
                });
          })
          .catch(() => {
            this.loading = false;
            this.$toasted.global.error({
              message: trans('app.error_occurred'),
            });
          });
    },
  },
  computed: {
    ...mapGetters(['mobileAppAccess', 'patient']),
    hasEmail() {
      return !!this.patient.email;
    },
    invitedToMobileApp() {
      return this.mobileAppAccess.status === 'invited';
    },
    invitationAccepted() {
      return this.mobileAppAccess.status === 'accepted';
    },
    appConfigured() {
      return this.mobileAppAccess.status === 'app_configured';
    },
    mobileAppStatus() {
      return trans('app.mobile_app.statuses.' + this.mobileAppAccess.status);
    },
  },
}
</script>
